import { useState } from "react";
import { CampoNumero, Pestanas, Resultado, Rejilla } from "../components/campos.jsx";
import { porcentajeDe, queePorcentajeEs, variacionPorcentual } from "../lib/calc.js";

const MODOS = [
  { valor: "de", etiqueta: "¿Cuánto es el X% de…?" },
  { valor: "es", etiqueta: "¿Qué % representa?" },
  { valor: "var", etiqueta: "Variación entre dos valores" },
];

export default function Porcentajes() {
  const [modo, setModo] = useState("de");
  const [a, setA] = useState(15);
  const [b, setB] = useState(2000);

  const resultados = {
    de: {
      campos: [
        { label: "Porcentaje (%)", valor: a, set: setA, sufijo: "%" },
        { label: "De la cantidad total", valor: b, set: setB, prefijo: "$" },
      ],
      valor: porcentajeDe(a, b),
      formato: (v) => v.toLocaleString("es-MX", { maximumFractionDigits: 2 }),
      nota: `El ${a}% de ${b.toLocaleString("es-MX")} `,
    },
    es: {
      campos: [
        { label: "Cantidad parcial", valor: a, set: setA, prefijo: "$" },
        { label: "Del total", valor: b, set: setB, prefijo: "$" },
      ],
      valor: queePorcentajeEs(a, b),
      formato: (v) => `${v.toLocaleString("es-MX", { maximumFractionDigits: 2 })}%`,
      nota: `${a.toLocaleString("es-MX")} sobre ${b.toLocaleString("es-MX")}`,
    },
    var: {
      campos: [
        { label: "Valor inicial", valor: a, set: setA },
        { label: "Valor final", valor: b, set: setB },
      ],
      valor: variacionPorcentual(a, b),
      formato: (v) => `${v > 0 ? "+" : ""}${v.toLocaleString("es-MX", { maximumFractionDigits: 2 })}%`,
      nota: b >= a ? "Aumento" : "Descenso",
    },
  }[modo];

  return (
    <div className="space-y-6">
      <Pestanas valor={modo} onChange={setModo} opciones={MODOS} />
      <Rejilla>
        <div className="space-y-4">
          {resultados.campos.map((c) => (
            <CampoNumero key={c.label} label={c.label} valor={c.valor} onChange={c.set} sufijo={c.sufijo} prefijo={c.prefijo} />
          ))}
        </div>
        <div className="order-first lg:order-last lg:col-span-2">
          <Resultado
            label="Resultado"
            valor={resultados.formato(resultados.valor)}
            nota={resultados.nota}
            tono={modo === "var" && resultados.valor < 0 ? "alerta" : "acento"}
          />
        </div>
      </Rejilla>
    </div>
  );
}
